import { call, put } from 'redux-saga/effects'

export function* cancellableCall(fn, params, args) {
  const { cancelToken = null, type } = Array.from(args).find((a) => a)

  const modParams = { ...params }

  if (cancelToken) {
    modParams.cancelToken = cancelToken
  }

  const { response, error } = yield call(fn, modParams)

  if (error && error.canceled) {
    yield put({ type: type + '_CANCELED' })
    return { canceled: true }
  }

  return { response, error }
}
